const responsibilities = [
    {
      title: 'Posting Opportunities',
      description: 'Established recruitment agencies maintain a list of top talent sourcing channels...',
    },
    {
      title: 'Building Relationships',
      description: 'In addition to attracting new prospective applicants using traditional sourcing channels...',
    },
    {
      title: 'Interviewing and Evaluating Talent',
      description: 'When recruitment agencies receive applications, they conduct one or more interviews...',
    },
    {
      title: 'Facilitating Final Interviews',
      description: 'After evaluating candidates, the agency shares a shortlist of top talent and schedules...',
    },
    {
      title: 'Extending Offers and Handling Negotiation',
      description: 'Once a decision is made, the recruitment agency reaches out to the individual with the company’s job offer...',
    },
    {
      title: 'Overseeing Onboarding and Administrative Paperwork',
      description: 'While some agencies are exclusively recruitment-focused and only involved until a worker is hired...',
    },
  ];
  
  export default responsibilities;